// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/village/divider.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.village_wrapper {
  width: 100%;
  position: relative;
}

.village_header_div {
  width: 100%;
  position: fixed;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.village_header_inner_div {
  /* width: 1443px; */
}
.band_img_div_village {
  width: 100%;
}

.band_img_div_village > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.village_main_div {
  width: 100%;
  padding-top: 80px;
  background-color: #fff !important;
}

.village_text_main_div {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.village_text_div {
  /* width: 1443px; */
  padding: 0 5vw;
}

.village_text_p1 {
  color: #ba1e24;
  font-family: Thicker;
  font-size: clamp(16px, 5vw, 24px);
  font-style: normal;
  font-weight: 400;
  line-height: 126.6%;
  text-transform: uppercase;
  margin: 45px 0 16px 0;
}

.village_text_p2 {
  color: #000;
  font-family: Thicker;
  font-size: clamp(20px, 5vw, 54px);
  font-style: normal;
  font-weight: 600;
  line-height: 126.6%;
  text-transform: capitalize;
}

.village_text_p4 {
  color: #000;
  font-family: "lightThicker";
  font-size: clamp(14px, 2vw, 20px);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 30px 0 45px 0;
}

.village_banner_div {
  width: 100%;
  /* height: 600px; */
  flex-shrink: 0;
}

.village_banner_div > img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.village_cards_div {
  width: 100%;
  padding: 30px 80px;
}

.village_dropdown > p {
  color: #000;
  font-family: "Thicker";
  font-size: clamp(14px, 2vw, 20px);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 30px */
  margin-bottom: 20px;
  letter-spacing: 0.8px;
}

.village_dropdown > div {
  width: 20%;
}

.photos-events {
  margin-top: 60px;
}

.photos-events > div {
  text-align: center;
  padding: 15px 0px;
  margin: 10px 0px;
  cursor: pointer;
  background: #1e1e1e;
  color: #fff;
  font-family: "Thicker";
  font-size: clamp(14px, 2vw, 20px);
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-transform: capitalize;
}

.village-divider {
  height: 80px;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: repeat;
}

.scroll-div {
  width: 100%;
  height: 35vw;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
}

.scroll-div > div {
  width: 50%;
  height: 100%;
}

.scrolldiv1 {
  padding: 0px 5vw;
  display: flex;
  align-items: center;
  justify-items: center;
  background-color: #fff;
}

.scrolldivone {
  padding: 0px 5vw;
  display: flex;
  align-items: center;
  justify-items: center;
  background: #262626;
}

.scrolldiv1 > div > label {
  padding-bottom: 7px;
  border-bottom: 5px solid #ba1e24;
  color: #000;
  font-size: clamp(16px, 3vw, 32px);
  font-style: normal;
  font-weight: 600;
  line-height: 126.6%;
  text-transform: capitalize;
}

.scrolldiv1 > div > p {
  color: #000;
  font-size: clamp(14px, 2vw, 18px);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 26px;
}

.scrolldivone > div > label {
  padding-bottom: 7px;
  border-bottom: 5px solid #ba1e24;
  color: #fff;
  font-size: clamp(16px, 3vw, 32px);
  font-style: normal;
  font-weight: 600;
  line-height: 126.6%;
  text-transform: capitalize;
}

.scrolldivone > div > p {
  margin-top: 26px;
  color: #fff;
  font-size: clamp(14px, 2vw, 18px);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  /* 27px */
}

.scrolldivimage {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.inscrolldiv2 {
  background-size: cover;
  display: none;
}

@media screen and (max-width: 1100px) {
  .village-divider {
    height: 6vw !important;
    background-size: cover;
  }
  .band_img_div_village {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 0 20px;
   }
   
   .band_img_div_village > img {
     width: 180%;
     height: 50px;
   }
}

@media screen and (max-width: 600px) {
  .band_img_div_village {
    width: 100%;
    padding: 0 !important;
    overflow: hidden;
   }
   
   .band_img_div_village > img {
     width: 280% !important; 
     height: 50px !important;
     margin-left: -50px;
   }
  .village-divider {
    height: 40px !important;
  }

  .scroll-div {
    height: 100% !important;
    display: block !important;
  }

  .scroll-div > div {
    width: 100% !important;
  }

  .scrolldiv1 {
    display: none !important;
    /* padding: 30px 5vw !important; */
  }

  .scrolldivone {
    display: none !important;
    /* padding: 30px 5vw !important; */
  }

  .scrolldiv2 {
    height: 500px !important;
  }

  /* ################################# */
  .scrolldivimage {
    display: none !important;
  }

  .inscrolldiv2 {
    height: 100%;
    width: 100%;
    display: block !important;
  }

  .contentvillage {
    display: flex;
    align-items: flex-end;
    padding: 0px 30px 50px 30px;
    height: 100%;
    justify-content: flex-end;
    background: #020216;
    background: linear-gradient(
      0deg,
      rgba(5, 5, 37, 0.676) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    transition: opacity 0.1s ease-in-out, transform 0.4s 0.2s;
  }

  .contentvillage > div > label {
    padding-bottom: 7px;
    border-bottom: 5px solid #ba1e24;
    color: #fff;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 126.6%;
    text-transform: capitalize;
  }

  .contentvillage > div > p {
    margin-top: 26px;
    color: #fff;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/thevillage/village.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yDAAuD;EACvD,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;GAChB;;GAEA;KACE,WAAW;KACX,YAAY;GACd;AACH;;AAEA;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;GACjB;;GAEA;KACE,sBAAsB;KACtB,uBAAuB;KACvB,kBAAkB;GACpB;EACD;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;EACpC;;EAEA;IACE,wBAAwB;IACxB,kCAAkC;EACpC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,2BAA2B;IAC3B,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB;;;;KAIC;IACD,yDAAyD;EAC3D;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF","sourcesContent":["@font-face {\n  font-family: lightThicker;\n  src: url(../../assets/fonts/Thicker-Regular.otf);\n}\n\n.village_wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.village_header_div {\n  width: 100%;\n  position: fixed;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n}\n\n.village_header_inner_div {\n  /* width: 1443px; */\n}\n.band_img_div_village {\n  width: 100%;\n}\n\n.band_img_div_village > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.village_main_div {\n  width: 100%;\n  padding-top: 80px;\n  background-color: #fff !important;\n}\n\n.village_text_main_div {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.village_text_div {\n  /* width: 1443px; */\n  padding: 0 5vw;\n}\n\n.village_text_p1 {\n  color: #ba1e24;\n  font-family: Thicker;\n  font-size: clamp(16px, 5vw, 24px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 126.6%;\n  text-transform: uppercase;\n  margin: 45px 0 16px 0;\n}\n\n.village_text_p2 {\n  color: #000;\n  font-family: Thicker;\n  font-size: clamp(20px, 5vw, 54px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%;\n  text-transform: capitalize;\n}\n\n.village_text_p4 {\n  color: #000;\n  font-family: \"lightThicker\";\n  font-size: clamp(14px, 2vw, 20px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin: 30px 0 45px 0;\n}\n\n.village_banner_div {\n  width: 100%;\n  /* height: 600px; */\n  flex-shrink: 0;\n}\n\n.village_banner_div > img {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n}\n\n.village_cards_div {\n  width: 100%;\n  padding: 30px 80px;\n}\n\n.village_dropdown > p {\n  color: #000;\n  font-family: \"Thicker\";\n  font-size: clamp(14px, 2vw, 20px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  /* 30px */\n  margin-bottom: 20px;\n  letter-spacing: 0.8px;\n}\n\n.village_dropdown > div {\n  width: 20%;\n}\n\n.photos-events {\n  margin-top: 60px;\n}\n\n.photos-events > div {\n  text-align: center;\n  padding: 15px 0px;\n  margin: 10px 0px;\n  cursor: pointer;\n  background: #1e1e1e;\n  color: #fff;\n  font-family: \"Thicker\";\n  font-size: clamp(14px, 2vw, 20px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  text-transform: capitalize;\n}\n\n.village-divider {\n  height: 80px;\n  width: 100%;\n  background-image: url(../../assets/village/divider.svg);\n  background-repeat: repeat;\n}\n\n.scroll-div {\n  width: 100%;\n  height: 35vw;\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n}\n\n.scroll-div > div {\n  width: 50%;\n  height: 100%;\n}\n\n.scrolldiv1 {\n  padding: 0px 5vw;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  background-color: #fff;\n}\n\n.scrolldivone {\n  padding: 0px 5vw;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  background: #262626;\n}\n\n.scrolldiv1 > div > label {\n  padding-bottom: 7px;\n  border-bottom: 5px solid #ba1e24;\n  color: #000;\n  font-size: clamp(16px, 3vw, 32px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%;\n  text-transform: capitalize;\n}\n\n.scrolldiv1 > div > p {\n  color: #000;\n  font-size: clamp(14px, 2vw, 18px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin-top: 26px;\n}\n\n.scrolldivone > div > label {\n  padding-bottom: 7px;\n  border-bottom: 5px solid #ba1e24;\n  color: #fff;\n  font-size: clamp(16px, 3vw, 32px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: 126.6%;\n  text-transform: capitalize;\n}\n\n.scrolldivone > div > p {\n  margin-top: 26px;\n  color: #fff;\n  font-size: clamp(14px, 2vw, 18px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  /* 27px */\n}\n\n.scrolldivimage {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n.inscrolldiv2 {\n  background-size: cover;\n  display: none;\n}\n\n@media screen and (max-width: 1100px) {\n  .village-divider {\n    height: 6vw !important;\n    background-size: cover;\n  }\n  .band_img_div_village {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    padding: 0 20px;\n   }\n   \n   .band_img_div_village > img {\n     width: 180%;\n     height: 50px;\n   }\n}\n\n@media screen and (max-width: 600px) {\n  .band_img_div_village {\n    width: 100%;\n    padding: 0 !important;\n    overflow: hidden;\n   }\n   \n   .band_img_div_village > img {\n     width: 280% !important; \n     height: 50px !important;\n     margin-left: -50px;\n   }\n  .village-divider {\n    height: 40px !important;\n  }\n\n  .scroll-div {\n    height: 100% !important;\n    display: block !important;\n  }\n\n  .scroll-div > div {\n    width: 100% !important;\n  }\n\n  .scrolldiv1 {\n    display: none !important;\n    /* padding: 30px 5vw !important; */\n  }\n\n  .scrolldivone {\n    display: none !important;\n    /* padding: 30px 5vw !important; */\n  }\n\n  .scrolldiv2 {\n    height: 500px !important;\n  }\n\n  /* ################################# */\n  .scrolldivimage {\n    display: none !important;\n  }\n\n  .inscrolldiv2 {\n    height: 100%;\n    width: 100%;\n    display: block !important;\n  }\n\n  .contentvillage {\n    display: flex;\n    align-items: flex-end;\n    padding: 0px 30px 50px 30px;\n    height: 100%;\n    justify-content: flex-end;\n    background: #020216;\n    background: linear-gradient(\n      0deg,\n      rgba(5, 5, 37, 0.676) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    transition: opacity 0.1s ease-in-out, transform 0.4s 0.2s;\n  }\n\n  .contentvillage > div > label {\n    padding-bottom: 7px;\n    border-bottom: 5px solid #ba1e24;\n    color: #fff;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 126.6%;\n    text-transform: capitalize;\n  }\n\n  .contentvillage > div > p {\n    margin-top: 26px;\n    color: #fff;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
